module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG73e2f130989e91c0c777758f7c586bf9.73e2f130.png";